<template>
  <!-- 首页 -->
  <div class="index" @click="closeSearchList">
    <!-- 头部 -->
    <Header :title="$theme.platformName" :showBack="false" :showClose="platformTerminalType === 5" />
    <SafeTips/>
    <!-- 机器人聊天内容 -->
    <div class="chat-content">
      <div class="content-box" id="content" @click="closeSearchList">
        <transition-group name="content" tag="ul" mode="out-in" appear>
          <li v-for="item in messageList" :key="item.randomKey" class="data-item" :class="{right : item.isUser}" v-show="!item.hidden">
            <!-- 系统消息 -->
            <div class="system-info" v-if="item.isSystem">{{ item.message }}</div>
            <!-- 对话消息 -->
            <div class="chat-message-item" v-else>
              <!-- 头像 -->
              <img class="avatar" :src="item.isUser ? require('../assets/img/yh_avatar.png') : $theme.kfImgUrl" alt="">
              <!-- 消息内容 -->
              <div class="message-outer">
                <!-- ai回答错误提示 -->
                <ErrorTips v-if="item.showError" />
                <!-- 思考内容折叠切换按钮 -->
                <div class="ai-think-fold-btn" @click="item.isFold = !item.isFold" v-if="item.hasThink">
                  <div class="ai-lead-title">{{ item.thinkEnded ? $lang.deeplyPondered : $lang.inDepthThinking }}</div>
                  <span v-if="item.thinkEnded">({{ item.thinkTime }})</span>
                </div>
                <!-- 渲染常见问题列表 -->
                <div class="suggest-container" v-if="item.type === 2 && item.problemList && item.problemList.length > 0">
                  <div>{{ $lang.questionsLead }}</div>
                  <div class="suggest-item" v-for="(sItem, sIndex) in item.problemList" :key="sIndex" @click="getAnswer(sItem)" :class="{red:sItem.colorFlag === 0}">
                    <span>{{sIndex+1}}.</span>
                    <span v-if="sItem.isHref === 0" v-html="sItem.content"></span>
                    <a class="problemLink" :href="sItem.answer" target="_blank" v-if="sItem.isHref === 1">{{sItem.content}}</a>
                  </div>
                </div>
                <!-- 渲染推荐问题列表 -->
                <div class="suggest-container" v-if="item.type === 3">
                  <div v-if="item.suggestList && item.suggestList.length > 0">{{ $lang.guessTips }}</div>
                  <div class="suggest-item" v-for="(sItem, sIndex) in item.suggestList" :key="sIndex" @click="getAnswer(sItem)">
                    <span>{{sIndex+1}}.</span>
                    <span v-if="sItem.isHref === 0" v-html="sItem.content"></span>
                    <a class="problemLink" :href="sItem.answer" target="_blank" v-if="sItem.isHref === 1">{{sItem.content}}</a>
                  </div>
                  <div>{{ $lang.noNeedContent }}</div>
                  <div class="blue cursor" @click="linkService">{{ $lang.transferService }}</div>
                </div>
                <!-- 直接渲染文本内容 -->
                <div class="message-text" :class="{'fold-think' : item.isFold}" v-html="item.message" v-else @click="handleImageClick($event.target.src)"></div>
                <div class="blue cursor" style="margin-top: 10px" @click="linkService" v-if="item.showLinkBtn">{{ $lang.transferService }}</div>
                <!-- 点评区域 -->
                <div class="grade-area" v-if="item.showGrade">
                  <div class="grade-item" @click="doGrade(item, graderItem)" v-for="(graderItem, gradeIndex) in gradeConfig" :key="gradeIndex">
                    <img class="grade-icon" :src="item.isItSolved === graderItem.type ? graderItem.selectedIcon : graderItem.defaultIcon" alt="">
                    <span class="grade-title">{{ graderItem.title }}</span>
                  </div>
                </div>
                <!-- loading -->
                <LoadingDot v-if="item.showLoading" />
              </div>
            </div>
          </li>
        </transition-group>
      </div>
    </div>
    <!-- 编辑区域 -->
    <div class="edit">
      <CourseSuspension v-if="showCourseCard" @close="showCourseCard = false" :showSendBtn="true" :courseInfo="$route.query" />
      <div class="edit-main">
        <el-input v-model="keyword" @input="handleInput" :placeholder="$lang.inputPlaceholder" @keyup.enter.native="sendQuestion"></el-input>
        <div class="stop-btn" v-if="showStopBtn" @click="stopRequest">
          <van-icon name="stop-circle-o" class="stop-icon" />
        </div>
        <div class="send-btn" @click="sendQuestion" v-else>{{ $lang.send }}</div>
      </div>
      <!-- 输入搜索推荐 -->
      <div class="search-list" v-if="searchList.length > 0">
        <div class="search-item" v-for="(item, index) in searchList" :key="index">
          <div v-if="item.isHref === 0" v-html="item.content" @click="clickSearch(item)" class="search-content"></div>
          <a class="problemLink" :href="item.answer" target="_blank" v-if="item.isHref === 1">{{item.content}}</a>
        </div>
      </div>
    </div>
     <!-- 图片预览 -->
    <div class="image-preview" v-if="showPreview" @click="showPreview = false">
      <img :src="previewImgSrc" alt="">
    </div>
    <!-- 无客服在线时 显示留言弹框 -->
    <div class="leave-message-container" v-if="showLeaveMessage">
      <div class="message">
        <p class="close" @click="closeLeaveMessage">x</p>
        <p class="tips">{{ $lang.problemFeedback }}</p>
        <div class="item">
          <p class="label">{{ $lang.account }}</p>
          <span class="input-area">
            <el-input v-model="leaveMessageForm.platformAccount" :placeholder="$lang.accountPlaceholder"></el-input>
          </span>
        </div>
        <div class="item">
          <p class="label">{{ $lang.registeredPhone }}</p>
          <span class="input-area">
            <el-input v-model="leaveMessageForm.phone" :placeholder="$lang.phonePlaceholder"></el-input>
          </span>
        </div>
        <div class="item alignTop">
          <p class="label">{{ $lang.problemDescription }}</p>
          <span class="input-area">
            <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 6}" :placeholder="$lang.problemDescriptionPlaceholder" resize="none" :maxlength="2000" v-model="leaveMessageForm.noteInfo"></el-input>
          </span>
        </div>
        <div class="submit-btn" @click="submitLeaveMessage" v-loading="isMessageSubmitLoading">{{ $lang.submit }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import isMobile from '../utils/isMobile'
import axios from 'axios'
import ErrorTips from '../components/ErrorTips.vue'
import LoadingDot from '../components/LoadingDot.vue'
import getTimeDistance from '../utils/getTimeDistance'
import CourseSuspension from '../components/CourseSuspension.vue'
import {getProblemInfo, updateProblemClickNum, submitProblemHelpRecord, sendChatMessages, queryImNoteSet, addImUser, submitImNoteRecord, imgOrTextCheck} from '../api/index'
import SafeTips from '../components/SafeTips.vue'
import $ from 'jquery'
import { Toast, ImagePreview } from 'vant'
import getSceneByQuery from '../utils/getSceneByQuery'
export default {
  activated () {
    this.showCourseCard = Boolean(this.$route.query.courseScheduleId)
    this.restoreScrollPosition()
  },
  async created () {
    this.isTeacher()
    this.getProblemList()
  },
  mounted () {
    // 用户id不存在时，生成随机id 并修改路由
    if (!this.$route.query.platformUserId) {
      this.updateUrlRandomUserId()
    }
    this.recordScrollPosition()
  },
  destroyed () {
  },
  components: {
    SafeTips,
    CourseSuspension,
    LoadingDot,
    ErrorTips
  },
  watch: {
    messageList () {
      this.scrollBottom()
    }
  },
  computed: {
    platformInfo () {
      return this.$store.state.platformInfo
    }
  },
  data () {
    return {
      // 是否已推送系统提示
      alreadyShowSystem: false,
      requestCancelSource: null,
      showStopBtn: false,
      leaveMessageForm: {
        platformType: this.$route.query.platformType ? Number(this.$route.query.platformType) : '',
        platformAccount: this.$route.query.platformUserId || '',
        phone: (['undefined', 'null', ''].includes(this.$route.query.platformPhone) ? '' : this.$route.query.platformPhone),
        noteInfo: ''
      },
      isMessageSubmitLoading: false,
      showLeaveMessage: false,
      // ai错误标志
      aiErrorSign: '!AI$service@response#exception&',
      // ai需连接客服标识
      linkServiceSign: '#convert@to&manual#labor*',
      scrollBottomTimer: null,
      gradeConfig: [
        {
          title: this.$lang.helpful,
          defaultIcon: require('../assets/img/helpful.png'),
          selectedIcon: require('../assets/img/helpful_selected.png'),
          type: 1
        },
        {
          title: this.$lang.useless,
          defaultIcon: require('../assets/img/unless.png'),
          selectedIcon: require('../assets/img/unless_selected.png'),
          type: 2
        }
      ],
      previewImgSrc: '',
      showPreview: false,
      messageList: [
        {
          randomKey: this.getRandomKey(),
          message: this.$lang.welcomeTxt.replace('%template%', this.$theme.platformName)
        }
      ],
      // 1 PC， 2安卓，3IOS，4平板，5小程序，6公众号
      platformTerminalType: Number(this.$route.query.platformTerminalType),
      showCourseCard: Boolean(this.$route.query.courseScheduleId),
      searchList: [],
      problemList: [],
      messageData: [],
      keyword: '',
      platformType: Number(this.$route.query.platformType),
      platformUserType: Number(this.$route.query.platformUserType),
      platformPhone: (['undefined', 'null', ''].includes(this.$route.query.platformPhone) ? '' : this.$route.query.platformPhone),
      platformUserId: this.$route.query.platformUserId || ''
    }
  },
  methods: {
    // 检验文本内容是否合格
    async checkSensitiveByText (text) {
      return new Promise((resolve, reject) => {
        imgOrTextCheck({
          // 1：机器人页面，2：客服页面
          pageType: 1,
          // 检查类型：1文本，2图片
          platformType: 5,
          twoPlatformId: this.platformType,
          checkType: 1,
          businessType: 5,
          violationContent: text,
          // 1表示安全合规校验
          scene: getSceneByQuery(this.$route.query)
        }).then(res => {
          if (res.resultCode === 0) {
            resolve(res.resultData.result)
          } else {
            reject(new Error(res.resultMessage))
          }
        }).catch(() => {
          reject(new Error(this.$lang.failInSend))
        })
      })
    },
    // 判断除去思考后有无内容
    getIsHaveAnswer (message) {
      let str = message.replace(/<think[^>]*>[\s\S]*?<\/think>/gi, '')
      return Boolean(str.length > 0)
    },
    // 终止请求
    stopRequest () {
      this.requestCancelSource.cancel()
      this.showStopBtn = false
    },
    // 修改路由中的随机用户id
    updateUrlRandomUserId () {
      let localKey = `${this.platformType}_randomUserId`
      let randomUserId = localStorage.getItem(localKey) || Math.round(Math.random() * Date.now())
      localStorage.setItem(localKey, randomUserId)
      let queryObj = this.$route.query
      queryObj.randomUserId = randomUserId
      let newQuery = ''
      Object.keys(queryObj).forEach(key => {
        newQuery = newQuery + (newQuery ? ('&' + key + '=' + queryObj[key]) : (key + '=' + queryObj[key]))
      })
      // 获取当前URL
      var url = window.location.href
      // 拼接新的URL
      var newUrl = url.split('?')[0] + '?' + newQuery
      // 修改地址栏URL
      history.pushState(null, null, newUrl)
    },
    // 关闭留言弹框
    closeLeaveMessage () {
      this.showLeaveMessage = false
      this.leaveMessageForm = {
        platformType: this.$route.query.platformType ? Number(this.$route.query.platformType) : '',
        platformAccount: this.$route.query.platformUserId || '',
        phone: (['undefined', 'null', ''].includes(this.$route.query.platformPhone) ? '' : this.$route.query.platformPhone),
        noteInfo: ''
      }
    },
    // 提交留言
    submitLeaveMessage () {
      if (this.isMessageSubmitLoading) {
        return
      }
      if (!this.leaveMessageForm.phone) {
        Toast(this.$lang.phonePlaceholder)
        return false
      }
      if (!/^1[3456789][0-9]{9}(,1[3456789][0-9]{9})*$/.test(this.leaveMessageForm.phone)) {
        Toast(this.$lang.errorPhoneTips)
        return false
      }
      if (!this.leaveMessageForm.noteInfo) {
        Toast(this.$lang.descriptionRequiredTips)
        return false
      }
      this.isMessageSubmitLoading = true
      submitImNoteRecord(this.leaveMessageForm).then(res => {
        if (res.data.resultCode === 0) {
          Toast(this.$lang.submittedSuccessfully)
          this.closeLeaveMessage()
        } else {
          Toast(res.data.resultMessage)
        }
      }).finally(() => {
        this.isMessageSubmitLoading = false
      })
    },
    // 判断有没有客服在线
    async isHaveServiceOnline () {
      let params = {
        ...this.$route.query,
        platformUserId: this.platformUserId,
        platformId: this.$theme.pid
      }
      const {data} = await addImUser(params)
      return data
    },
    // 判断当前时间是否在留言设置时间内
    isTimeInMessageRange ({startTime, endTime}) {
      const now = new Date()
      const currentHours = now.getHours()
      const currentMinutes = now.getMinutes()
      const currentTimeInMinutes = currentHours * 60 + currentMinutes
      const [startHours, startMinutes] = startTime.split(':').map(Number)
      const startTotalMinutes = startHours * 60 + startMinutes
      const [endHours, endMinutes] = endTime.split(':').map(Number)
      const endTotalMinutes = endHours * 60 + endMinutes
      return currentTimeInMinutes >= startTotalMinutes && currentTimeInMinutes <= endTotalMinutes
    },
    // 查询是否开启留言
    async getIsInMessageTime () {
      try {
        let params = {
          platformId: this.$theme.pid
        }
        const {data} = await queryImNoteSet(params)
        if (data.resultCode === 0) {
          if (data.resultData.switchs === 1 && this.isTimeInMessageRange(data.resultData)) {
            // 配置开启并且在留言时间内
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } catch (error) {
        return false
      }
    },
    // 恢复滚动位置
    restoreScrollPosition () {
      let contentElement = document.querySelector('#content')
      contentElement && (contentElement.scrollTop = this.$route.meta.scrollTop || 0)
    },
    // 记录页面滚动位置
    recordScrollPosition (e) {
      document.querySelector('#content').addEventListener('scroll', (e) => {
        this.$route.meta.scrollTop = e.srcElement.scrollTop
      }, true)
    },
    getRandomKey () {
      return Math.round(Math.random() * Date.now())
    },
    // 提取纯文本
    getOnlyText (html) {
      try {
        let re = new RegExp('<.+?>|&nbsp;', 'g')
        let text = html.replace(re, '').trim()
        return text
      } catch (error) {
        return ''
      }
    },
    // 富文本中的图片点击
    handleImageClick (src) {
      if (!src) {
        return
      }
      if (isMobile()) {
        // 移动设备
        ImagePreview({
          images: [src],
          showIndex: false
        })
      } else {
        // 电脑设备
        this.previewImgSrc = src
        this.showPreview = true
      }
    },
    closeSearchList () {
      this.searchList = []
    },
    handleInput () {
      if (!this.keyword.trim()) {
        this.searchList = []
        return
      }
      let data = {
        keyword: this.keyword,
        platformId: this.platformType,
        userId: this.platformUserId || ''
      }
      getProblemInfo(data).then(res => {
        if (res.data.resultCode === 0) {
          this.searchList = res.data.resultData || []
        }
      })
    },
    // base64转文件
    dataURLtoFile (dataurl, filename) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, {type: mime})
    },
    // 说客的教师直接跳转到客服咨询页
    isTeacher () {
      if (this.$route.query.platformType === '0' && this.$route.query.platformUserType === '2' && !this.$route.query.isStay) {
        this.linkService()
      }
    },
    // 常见问题点击数量记录
    recordProblemClickNum (id) {
      let data = {
        id: id
      }
      updateProblemClickNum(data).then()
    },
    // 返回并退出登录
    goBack () {
      let promise = this.tim.logout()
      promise.then((imResponse) => {
        this.$router.go(-1)
      }).catch((imError) => {
        Toast(imError)
      })
    },
    // 将路由中的课程信息参数删掉
    updateUrl () {
      let queryObj = this.$route.query
      if (queryObj.courseScheduleId) {
        delete queryObj.courseScheduleId
        delete queryObj.sellCourseScheduleId
        delete queryObj.classType
        delete queryObj.courseScheduleName
        delete queryObj.courseScheduleImg
        delete queryObj.teacherName
        delete queryObj.courseSellPrice
      }
      let newQuery = ''
      Object.keys(queryObj).forEach(key => {
        newQuery = newQuery + (newQuery ? ('&' + key + '=' + queryObj[key]) : (key + '=' + queryObj[key]))
      })
      // 获取当前URL
      var url = window.location.href
      // 拼接新的URL
      var newUrl = url.split('?')[0] + '?' + newQuery
      // 修改地址栏URL
      history.pushState(null, null, newUrl)
    },
    // 连接人工客服
    linkService () {
      this.updateUrl()
      this.$router.push({
        name: 'Service',
        query: {
          ...this.$route.query
        }
      })
    },
    getAiAnswer (messageItem, data) {
      messageItem.showLoading = false
      let lines = data.split('\n')
      lines.forEach(async line => {
        let content = line.replace(/\\n/g, '<br>')
        if (line.startsWith('data:')) {
          content = line.substring(5).replace(/\\n/g, '<br>')
        }
        // 连接客服
        if (content === this.linkServiceSign) {
          messageItem.message = this.$lang.linkService
          if (await this.getIsInMessageTime()) {
            // 留言开启
            messageItem.message = this.$lang.noInServiceTimeTips + `<span class="leave-message-btn"> ${this.$lang.leaveAMessage}</span>`
            this.$nextTick(() => {
              $('.leave-message-btn').click(() => {
                this.showLeaveMessage = true
              })
            })
            this.scrollBottom()
          } else {
            // 获取客服在线信息
            let onlineInfo = await this.isHaveServiceOnline()
            if (onlineInfo.resultCode === 0) {
              // 跳转客服连接
              this.linkService()
              setTimeout(() => {
                messageItem.message = this.$lang.linkFinished
              }, 1000)
            } else {
              // 给出错误提示
              messageItem.message = this.$lang.noOnlineServiceTips
              this.scrollBottom()
            }
          }
          return
        }
        // 请求出错
        if (content === this.aiErrorSign) {
          // 接口错误
          messageItem.message = ''
          messageItem.showLoading = false
          messageItem.showError = true
          this.showStopBtn = false
          return
        }
        // 检测到新行
        if (content.includes('<br>')) {
          this.scrollBottom()
        }
        // 开始思考
        if (content.includes('<think>')) {
          messageItem.startThinkTimestamp = Date.now()
          messageItem.hasThink = true
        }
        messageItem.message += content
        // 思考结束
        if (content.includes('</think>')) {
          // 计算思考时间
          messageItem.thinkTime = getTimeDistance(Date.now() - messageItem.startThinkTimestamp, {shortUnit: true})
          messageItem.isFold = true
          messageItem.thinkEnded = true
          this.scrollBottom()
        }
      })
    },
    // 处理返回.need_send_btn按钮的点击
    handleNeedSendClick () {
      this.$nextTick(() => {
        document.querySelectorAll('.need_send_btn').forEach(btn => {
          btn.onclick = (e) => {
            if (this.showStopBtn) {
              return Toast(this.$lang.aiWaitTips)
            }
            this.messageList.push({
              isUser: true,
              randomKey: this.getRandomKey(),
              message: e.target.innerText
            })
            this.doAskAi(e.target.innerText)
          }
        })
      })
    },
    doAskAi (query) {
      if (this.showStopBtn) {
        return Toast(this.$lang.aiWaitTips)
      }
      // 向ai询问
      let messageItem = {
        randomKey: this.getRandomKey(),
        message: ''
      }
      this.showStopBtn = true
      messageItem.showLoading = true
      this.messageList.push(messageItem)
      let params = {
        platformType: this.platformType,
        platformUserType: this.platformUserType,
        platformPhone: this.platformPhone,
        platformTerminalType: this.platformTerminalType,
        userId: this.platformUserId || this.$route.query.randomUserId,
        query: query,
        platformId: this.platformInfo.pid
      }
      this.requestCancelSource = axios.CancelToken.source()
      // 第二个参数为接受到的流数据
      sendChatMessages(params, (chunk) => this.getAiAnswer(messageItem, chunk), this.requestCancelSource).then(res => {
        // 请求完毕
        if (!res.data) {
          // 没有响应任何内容
          messageItem.message = `<span class="gray">${this.$lang.noFindContentTips}</span>`
          messageItem.showLinkBtn = true
        } else {
          messageItem.showGrade = true
        }
        this.handleNeedSendClick()
        // 完成一次回答后，推送系统提示
        // if (!this.alreadyShowSystem) {
        //   this.alreadyShowSystem = true
        //   setTimeout(() => {
        //     this.messageList.push({
        //       randomKey: this.getRandomKey(),
        //       isSystem: true,
        //       message: this.$lang.linkServiceHelpTips
        //     })
        //   }, 500)
        // }
      }).catch((error) => {
        if (axios.isCancel(error)) {
          // 请求取消
          // 判断是否有回答内容
          let isHaveAnswer = this.getIsHaveAnswer(messageItem.message)
          if (isHaveAnswer) {
            messageItem.message += '...'
          } else {
            let currentMessageIndex = this.messageList.findIndex(item => item.randomKey === messageItem.randomKey)
            currentMessageIndex >= 0 && this.messageList.splice(currentMessageIndex, 1)
          }
        } else {
          // 接口错误
          messageItem.message = ''
          messageItem.showError = true
        }
      }).finally(() => {
        messageItem.showLoading = false
        messageItem.thinkEnded = true
        this.showStopBtn = false
        this.scrollBottom()
      })
    },
    async sendQuestion () {
      if (this.showStopBtn) {
        return Toast(this.$lang.aiWaitTips)
      }
      if (!this.keyword.trim()) {
        Toast(this.$lang.searchNoEmptyTips)
        return
      }
      let query = this.keyword.trim()
      this.keyword = ''
      this.searchList = []
      let messageItem = {
        randomKey: this.getRandomKey(),
        message: query,
        isUser: true
      }
      this.messageList.push(messageItem)
      this.checkSensitiveByText(query).then(res => {
        if (res) {
          // 敏感词校验通过
          if (this.platformInfo.isAiSendMsg === 1) {
            this.doAskAi(query)
          } else {
            // 调用常见问题列表
            let data = {
              keyword: query,
              platformId: this.platformType,
              userId: this.platformUserId || ''
            }
            getProblemInfo(data).then(res => {
              if (res.data.resultCode === 0) {
                this.messageList.push({
                  type: 3,
                  randomKey: this.getRandomKey(),
                  suggestList: res.data.resultData || []
                })
              }
            }).finally(() => {
            })
          }
        } else {
          // 敏感词校验不通过
          messageItem.hidden = true
          this.$forceUpdate()
          Toast(this.$lang.textNotCompliantTips)
        }
      }).catch(errorMsg => {
        messageItem.hidden = true
        this.$forceUpdate()
        Toast((errorMsg + '').replace('Error:', ''))
      })
    },
    doGrade (problemItem, gradeItem) {
      if (problemItem.isItSolved) {
        return this.$toast(this.$lang.alreadyEvaluatedTips)
      }
      if (problemItem.id) {
        let params = {
          isItSolved: gradeItem.type,
          platformUserId: this.platformUserId,
          problemId: problemItem.id
        }
        submitProblemHelpRecord(params).then(res => {
          if (res.data.resultCode === 0) {
            this.$set(problemItem, 'isItSolved', gradeItem.type)
            this.$forceUpdate()
          } else {
            this.$message.error(res.data.resultMessage)
          }
        })
      } else if (this.platformInfo.isAiSendMsg === 1) {
        this.$set(problemItem, 'isItSolved', gradeItem.type)
        // 发送给ai
        this.messageList.push({
          isUser: true,
          message: gradeItem.title,
          randomKey: this.getRandomKey()
        })
        this.doAskAi(gradeItem.title)
      }
    },
    clickSearch (item) {
      this.keyword = ''
      this.getAnswer(item)
    },
    // 获取机器人回复结果
    getAnswer (item) {
      this.recordProblemClickNum(item.id)
      if (item.isHref === 1) {
        // 直接链接跳转
        return
      }
      this.messageList.push({
        randomKey: this.getRandomKey(),
        message: item.content,
        isUser: true
      })
      this.$nextTick(() => {
        let messageItem = {
          id: item.id,
          randomKey: this.getRandomKey(),
          message: ''
        }
        this.messageList.push(messageItem)
        // 打字机效果
        let fullAnswer = this.getOnlyText(item.answer)
        let index = 0
        messageItem.timer = setInterval(() => {
          if (index < fullAnswer.length) {
            messageItem.message += fullAnswer.charAt(index)
            index++
          } else {
            clearInterval(messageItem.timer)
            messageItem.message = item.answer
            messageItem.showGrade = true
            this.$forceUpdate()
            this.scrollBottom()
          }
        }, 10)
      })
    },
    // 获取问题列表
    getProblemList () {
      let data = {
        keyword: '123',
        platformId: this.platformType,
        userId: this.platformUserId || ''
      }
      getProblemInfo(data).then(res => {
        if (res.data.resultCode === 0) {
          let problemList = res.data.resultData
          if (problemList.length > 0) {
            this.messageList.push({
              type: 2,
              randomKey: this.getRandomKey(),
              problemList: problemList,
              showLinkBtn: Boolean(this.platformInfo.isAiSendMsg === 2)
            })
          }
        }
      })
    },
    // 滚动到底部
    scrollBottom () {
      clearTimeout(this.scrollBottomTimer)
      this.scrollBottomTimer = setTimeout(() => {
        let container = $('#content')
        const scrollHeight = container.prop('scrollHeight')
        const clientHeight = container.prop('clientHeight')
        const scrollTo = scrollHeight - clientHeight
        container.animate({
          scrollTop: scrollTo
        })
      }, 300)
    }
  }
}
</script>

<style lang="less" scoped>
.index{
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #F9F9F9;
  // 机器人聊天内容
  .chat-content{
    position: relative;
    flex: 1;
    background: #F9F9F9;
    .content-box{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow-y: auto;
      padding: 0 16px;
      padding-bottom: 80px;
      background: #F9F9F9;
      .data-item{
        &.right .chat-message-item{
          flex-direction: row-reverse;
          .message-outer{
            background-color: #0087FF;
            color: #fff;
            border-radius: 8px 1px 8px 8px;
          }
        }
        .system-info{
          width: fit-content;
          padding: 5px 8px;
          max-width: 60vw;
          background-color: #ddd;
          color: #fff;
          font-size: 12px;
          border-radius: 4px;
          margin: 10px auto;
        }
        .chat-message-item{
          display: flex;
          gap: 8px;
          margin-top: 24px;
          .avatar{
            width: 36px;
            height: 36px;
          }
          .stop-answer-btn{
            align-self: flex-end;
            margin-bottom: 10px;
          }
          /deep/.message-outer{
            max-width: 60vw;
            padding: 8px 12px;
            background-color: #fff;
            border-radius: 1px 8px 8px 8px;
            line-height: 24px;
            .message-text{
              word-wrap: break-word;
              overflow-wrap: break-word;
              white-space: normal;
              *{
                max-width: 100%;
                word-break: break-all!important;
                white-space: pre-wrap!important;
              }
              a{
                color: #0087ff;
              }
              .blue{
                *{
                  color: #0087ff;
                  cursor: pointer;
                }
              }
              .red{
                *{
                  color: red!important;
                }
              }
              img{
                cursor: pointer;
              }
              think{
                height: fit-content;
                display: none;
                padding: 0 10px 24px;
                background-color: #eee;
                border-radius: 8px;
                margin-bottom: 20px;
                // font-size: 12px;
                transition: all 0.5s ease-out;
              }
              &.fold-think think{
                display: none;
                height: 0;
                overflow: hidden;
                transition: all 0.5s ease-in;
              }
            }
            .suggest-container{
              .suggest-item{
                color: #0087ff;
                cursor: pointer;
                a{
                  color: #0087FF;
                }
                &.red *{
                  color: red!important;
                }
              }
            }
            .ai-think-fold-btn{
              display: flex;
              gap: 10px;
              align-items: center;
              color: #666;
              margin-bottom: 10px;
              .fold-icon{
                font-weight: 600;
              }
              .ai-lead-title{
                display: flex;
              }
            }
          }
          .grade-area{
            display: flex;
            border-top: 1px solid #f1f2f4;
            margin-top: 10px;
            min-width: 40vw;
            .grade-item{
              cursor: pointer;
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
              flex: 1;
              height: 40px;
              .grade-icon{
                width: 16px;
              }
              .grade-title{
                color: #666;
              }
              &:first-child{
                &::after{
                  position: absolute;
                  right: 0;
                  top: 50%;
                  transform: translateY(-50%);
                  display: block;
                  content: '';
                  width: 2px;
                  height: 20px;
                  background-color: #f1f2f4;
                }
              }
            }
          }
        }
      }
    }
  }
  .edit{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    height: 56px;
    padding: 0 5px;
    background-color: #F9F9F9;
    box-shadow: 0px -10px 20px 0px rgba(80, 106, 150, 0.08);
    /deep/.course-suspension-container{
      position: absolute;
      top: -32px;
      left: 16px;
      right: 16px;
      animation: courseMove 1s forwards;
      -moz-animation: courseMove 1s forwards;
      -webkit-animation: courseMove 1s forwards;
      -o-animation: courseMove 1s forwards;
    }
    .edit-main{
      width: 100%;
      display: flex;
      align-items: center;
      height: 100%;
      background-color: #F9F9F9;
      z-index: 2;
      /deep/.el-input__inner{
        border: none;
        &:focus{
          border: transparent;
        }
      }
      .send-btn, .stop-btn{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 58px;
        height: 36px;
        border-radius: 6px;
        color: #fff;
        background-color: var(--main-color);
        margin-left: 5px;
        cursor: pointer;
        .stop-icon{
          color: #fff;
          font-size: 30px;
          animation: stopBtn .8s infinite alternate;
          -moz-animation: stopBtn .8s infinite alternate;
          -webkit-animation: stopBtn .8s infinite alternate;
          -o-animation: stopBtn .8s infinite alternate;
        }
      }
    }
    .search-list{
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      transform: translateY(-100%);
      background-color: #fff;
      box-shadow: 0px 2px 12px 0px #eee;
      max-height: 60vh;
      overflow-y: auto;
      .search-item{
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        a{
          color: #666!important;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: block;
        }
        .search-content{
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &:hover{
          background-color: #eee;
        }
        &:active{
          background-color: #eee;
        }
      }
    }
  }
  .image-preview{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .6);
    z-index: 1000;
    img{
      // max-height: 396px;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  /* 留言弹框 */
  .leave-message-container{
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .4);
    .message{
      position: fixed;
      width: 90%;
      max-width: 554px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border: 1px solid #ccc;
      padding: 20px;
      border-radius: 5px;
      background-color: #fff;
      box-sizing: 4px 4px 5px #eee;
      .close{
        position: absolute;
        right: -13px;
        top: -13px;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        line-height: 26px;
        background-color: #C0C4CC;
        color: #fff;
        text-align: center;
      }
      .submit-btn{
        width: 80%;
        margin: 8px auto 0;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 8px;
        color: #fff;
        background-color: var(--main-color);
      }
      .tips{
        text-align: center;
        margin-bottom: 20px;
      }
      .notice{
        color: #666;
        font-size: 12px;
        margin-bottom: 10px;
      }
      .item{
        display: flex;
        align-items: center;
        margin-bottom: 15px;
      }
      .label{
        width: 100px;
      }
      .alignTop{
        align-items: flex-start;
      }
      .input-area{
        flex: 1;
        input{
          width: 100%;
          // width: 90px;
          padding-left: 5px;
          height: 30px;
          border-radius: 5px;
          border: 1px solid #C0C4CC;
          outline: none;
        }
        textarea{
          width: 100%;
          padding: 5px;
          border-radius: 5px;
          border: 1px solid #C0C4CC;
          outline: none;
          resize: none;
        }
        select{
          height: 30px;
          width: 100%;
          border-radius: 5px;
          border: 1px solid #C0C4CC;
          outline: none;
        }
      }
    }
  }
}
// 课程悬浮动画效果
@keyframes courseMove
{
  from {
    transform: translateY(60%);
    opacity: 0;
  }
  to {
    transform: translateY(-100%);
    opacity: 1;
  }
}
@-moz-keyframes courseMove
{
  from {
    transform: translateY(60%);
    opacity: 0;
  }
  to {
    transform: translateY(-100%);
    opacity: 1;
  }
}
@-webkit-keyframes courseMove
{
  from {
    transform: translateY(60%);
    opacity: 0;
  }
  to {
    transform: translateY(-100%);
    opacity: 1;
  }
}
@-o-keyframes courseMove
{
  from {
    transform: translateY(60%);
    opacity: 0;
  }
  to {
    transform: translateY(-100%);
    opacity: 1;
  }
}
/* 定义消息进入动画 */
.content-enter-active {
  transition: all 0.5s ease;
}
.content-enter {
  opacity: 0;
  transform: translateX(-30px);
}
.right.content-enter {
  opacity: 0;
  transform: translateY(60px);
}
/deep/.leave-message-btn{
  color: var(--main-color);
  text-decoration: underline;
}
// 停止按钮动画
@keyframes stopBtn
{
  from {
    transform: scale(1.0);
  }
  to {
    transform: scale(.9);
  }
}
@-moz-keyframes stopBtn
{
  from {
    transform: scale(1.0);
  }
  to {
    transform: scale(.9);
  }
}
@-webkit-keyframes stopBtn
{
  from {
    transform: scale(1.0);
  }
  to {
    transform: scale(.9);
  }
}
@-o-keyframes stopBtn
{
  from {
    transform: scale(1.0);
  }
  to {
    transform: scale(.9);
  }
}
/deep/.need_send_btn{
  text-decoration: underline;
  cursor: pointer;
  color: var(--main-color);
  &:active{
    opacity: .7;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue